export default class Toggle {
  onlyOpen = 'data-open';
  onlyClose = 'data-close';
  openClass = 'opened';
  activeClass = 'active';
  timer: number = null;

  constructor() {
    const toggle = $('.js-toggle');

    if (toggle.length) {
      toggle.on('click', this.handler.bind(this));
      this.hashHandler();
    }
  }

  handler(ev: Event) {
    const trigger = (ev.currentTarget) as HTMLElement;
    const triggerWrapper = $(trigger).closest('.js-toggle-wrap');
    let contentId = triggerWrapper.attr('data-toggleId').split(' ');
    const content = $(`#${contentId[0]}`);

    if (content.length) {
      const isCloseOnly =
        trigger.getAttribute(this.onlyClose) ||
        trigger.hasAttribute(this.onlyClose);
      const isOpenOnly =
        trigger.getAttribute(this.onlyOpen) ||
        trigger.hasAttribute(this.onlyOpen);

      // Only to open element by ID provided from trigger
      if (isOpenOnly) {
        return this.onlyOpenElement(content, triggerWrapper);
      }

      // Only to close opened elements by ID provided from trigger
      if (isCloseOnly) {
        /*
            remove all active class from triggers
            example laguage region selector
        */
        if (isCloseOnly === 'all') {
          $(`.js-toggle-wrap[data-toggleId="${contentId}"]`).removeClass(
            this.activeClass
          );
        }

        /**
         * if there is more content close them all
         * example navigation and mega menu relation on mobile devices
         */
        if (contentId.length > 1) {
          return this.closeAllOpenedById(contentId);
        }

        content.removeClass(this.openClass);
        triggerWrapper.removeClass(this.activeClass);

        return;
      }

      content.toggleClass(this.openClass);
      triggerWrapper.toggleClass(this.activeClass);
    }
  }

  /**
   * Close all opened elements by provided id from close trigger
   * @param contentId - array of opened elements
   * @returns
   */
  closeAllOpenedById(contentId: string[]) {
    return contentId.forEach(id => {
      $(`.js-toggle-wrap[data-toggleId="${id}"]`).removeClass(this.activeClass);
      $(`#${id}`).removeClass(this.openClass);
    });
  }

  /**
   * Open content by provided id from trigger
   * @param content html element to open
   * @param triggerWrapper trigger
   */
  onlyOpenElement(content: JQuery<HTMLElement>, triggerWrapper: JQuery<HTMLElement>) {
    content.addClass(this.openClass);
    triggerWrapper.addClass(this.activeClass);
  }

  /**
   * Automaticly opens accordion or dropdown if there is # in url
   * Notes: #{name} and html element id="toggle-{name}" needs to be same
   */
  hashHandler() {
    const hash = window.location.hash.slice(1);
    window.clearTimeout(this.timer);
    if (hash) {
      const hashElem = document.querySelector(`#toggle-${hash}`);
      if (hashElem) {
        const jsToggleWrap = hashElem.parentElement;
        if (jsToggleWrap.classList.contains('js-toggle-wrap')) {
          this.timer = window.setTimeout(() => {
            const hashElem = document.querySelector(`#toggle-${hash}`);
            const jsToggleWrap = hashElem.parentElement;
            if (jsToggleWrap.classList.contains('js-toggle-wrap')) {
              $('html, body')
                .stop()
                .animate(
                  {
                    scrollTop: $(jsToggleWrap).offset().top - 100
                  },
                  {
                    duration: 1000,
                    complete: () => {
                      const nested = jsToggleWrap.parentElement.closest('.js-toggle-wrap');
                      if(nested) {
                        nested.classList.add('active')
                      }
                      jsToggleWrap.classList.add('active')

                    }
                  }
                );
            }
          }, 1000);
        }
      }
    }
  }
}
